/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Audience_Heading1Inputs */

const zh_landing_audience_heading1 = /** @type {(inputs: Landing_Audience_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为`)
};

const en_landing_audience_heading1 = /** @type {(inputs: Landing_Audience_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Made for`)
};

const es_landing_audience_heading1 = /** @type {(inputs: Landing_Audience_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho para`)
};

/**
* | output |
* | --- |
* | "Made for" |
*
* @param {Landing_Audience_Heading1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_audience_heading1 = /** @type {((inputs?: Landing_Audience_Heading1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Audience_Heading1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_audience_heading1(inputs)
	if (locale === "en") return en_landing_audience_heading1(inputs)
	return es_landing_audience_heading1(inputs)
});